import { writable, derived } from "svelte/store";
import type { currentUserType } from "../../../Pages/types";

// Create a writable store for the current user
export const currentUser = writable<currentUserType | null>(null);

// Derived store for user settings
export const userSettings = derived(currentUser, ($currentUser) => $currentUser?.settings || {});

// Derived store specifically for richtext_save_by_enter setting
export const richtextSaveByEnter = derived(
  userSettings,
  ($userSettings) => Boolean($userSettings?.richtext_save_by_enter)
);

// Function to initialize the current user from page props
export function initializeCurrentUser(user: currentUserType) {
  currentUser.set(user);
}

// Function to update a specific setting
export function updateUserSetting(key: string, value: any) {
  currentUser.update((user) => {
    if (user) {
      if (!user.settings) {
        user.settings = {};
      }
      user.settings[key] = value;
    }
    return user;
  });
}
